import request from '@/api/backend/universal.js'
/**
 * 官网bannber
 * type 1外部链接 2自定义内容 3内部链接
 */
export function getBanner(query) {
    return request.get('/index/getBanner', { params: query });
}
/**
 * 引擎官网游戏列表
 * scene 场景:1=合作案例,2=游戏管理,3=文章管理
 * game_tag 游戏标签:1=近期测试,2=正版授权,3=违规游戏公示(scene=2的时候传递)
 */
export function engineGame(query) {
    return request.get('/index/engineGame', { params: query });
}
/**
 * 原创游戏展示
 */
export function getEngineMedia(query) {
    return request.get('/index/getEngineMedia', { params: query });
}
